import { createLazyFileRoute } from "@tanstack/react-router";

import { NewProviderPage } from "@/features/admin/routes/AuthProviderNew";

export const Route = createLazyFileRoute("/_auth/admin/auth/providers/new")({
  component: NewProviderPage,
});
